import { useRef as s, useImperativeHandle as f } from "react";
const c = (n, o) => {
  const r = {};
  for (const e of o)
    r[e] = s(null);
  return f(n, () => {
    const e = {};
    for (const t of o)
      e[t] = r[t].current;
    return e;
  }), r;
};
export {
  c as m
};
//# sourceMappingURL=make-refs.cb0b9b76.js.map
